<button type="button" id="btnRevert" (click)="articleRevert()" style="display:none">Revert</button>
<button type="button" id="btnManualPagination" (click)="articleManualPagination()" style="display:none">Revert</button>
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnPopupartMeta" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>

        <div id="divArticleInfoMetadata" class="modal" [style.display]="showInfoMetadataModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="top:-15px;position:relative;">
                <ul class="nav nav-tabs nav-tabs-custom" id="tabULArtStatusMeta">
                  <li class="nav-item">
                    <a data-toggle="tab" href="#ArtStatus" class="nav-link active">
                      <h4 class="modal-title">Article Status</h4>
                    </a>
                  </li>
                  
                </ul>
                <button type="button" class="close" data-dismiss="modal" (click)="hideInfoModal()">×</button>
              </div>
              <div class="modal-body" style="overflow: hidden !important; position: relative; top: -30px;" id="divArticleModule">

                <div class="row">
                  <div class="form-group fixTableHead" id="divWorkflow" style="overflow:auto;">
                    <table id="tblWorkflow" class="dataTable table " style="width: 100%">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Stage</th>
                          <th>Planned Date</th>
                          <th>Revised Schedule</th>
                          <th>Actual Completed</th>
                          <th class="dt-head-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

          <div id="LoadingImageMeta">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
          </div>


        </div>

      </div>
    </div>
  </div>
</div>
